import { render } from "./CreateAccount.vue?vue&type=template&id=3eb62d71&scoped=true"
import script from "./CreateAccount.vue?vue&type=script&lang=js"
export * from "./CreateAccount.vue?vue&type=script&lang=js"

import "@/assets/styles/login.css?vue&type=style&index=0&id=3eb62d71&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb62d71"]])

export default __exports__